import moment from "moment";
import { chamSocKhachHangApi } from "../../api/chamSocKhachHangApi";
import { khoLeadApi } from "../../api/khoLeadApi";
import { ts_chamsockhachhang } from "../../models/response/cskh/ts_chamsockhachhang";
import { IKhoLeadInteractionVm } from "../../models/response/crm-survey/IKhoLead";

// Một dòng lịch sử chăm sóc (bảng ts_chamsockhachhang) đã chuẩn hoá để CSKH và Kho Lead hiển thị như nhau
export interface ICareItem extends ts_chamsockhachhang {
    // Tạo từ Kho Lead: sửa bằng modal của Lead, xác nhận xử lý không nhập kết quả
    isLead: boolean;
}

// Nguồn dữ liệu: theo phụ huynh (CSKH) hoặc theo Lead (Kho Lead, kèm phụ huynh nếu Lead đã gắn)
export type tCareSource =
    | { kind: "phuhuynh"; ts_phuhuynh_id: number }
    | { kind: "lead"; crm_lead_id: number; ts_phuhuynh_id?: number };

// Bản ghi Lead ghi tên kết quả liên hệ vào ket_qua_xu_ly (SP crm_lead_log_activity), chuyển về đúng chỗ
export const fromCskhRow = (row: ts_chamsockhachhang): ICareItem => {
    const isLead = !!row.crm_survey_respone_id;
    if (isLead && !row.dm_ket_qua_lien_he_id) {
        return { ...row, isLead, ten_ket_qua_lien_he: row.ket_qua_xu_ly || null, ket_qua_xu_ly: "" };
    }
    return { ...row, isLead };
};

const fromLeadInteraction = (x: IKhoLeadInteractionVm): ICareItem => ({
    id: x.id,
    crm_survey_respone_id: x.crm_lead_id,
    dien_thoai: "",
    ten_khach_hang: "",
    noi_dung: x.content,
    ts_hocsinh_id: 0,
    // API cũ chưa trả da_xu_ly: không có lịch hẹn thì coi như đã xử lý
    da_xu_ly: x.da_xu_ly ?? !x.appointment,
    ngay_xu_ly: x.ngay_xu_ly ?? null,
    user_xu_ly_id: 0,
    ghi_chu: x.note ?? "",
    ts_phuhuynh_id: 0,
    ts_hoso_survey_id: 0,
    ket_qua_xu_ly: "",
    is_request: false,
    ngay_hen_tra_loi: x.appointment ?? null,
    dm_loai_lien_he_id: x.dm_loai_lien_he_id ?? null,
    ten_loai_lien_he: x.ten_loai ?? null,
    ten_ket_qua_lien_he: x.result ?? null,
    nguoi_tao: x.ten_nguoi_thuc_hien,
    ngay_tao: x.created_time,
    isLead: true,
});

const toTime = (value?: string) => {
    const m = value ? moment(value, ["DD/MM/YYYY HH:mm:ss", moment.ISO_8601]) : null;
    return m && m.isValid() ? m.valueOf() : 0;
};

export const loadCareItems = async (source: tCareSource): Promise<ICareItem[]> => {
    const items: ICareItem[] = [];
    if (source.kind === "lead") {
        const res = await khoLeadApi.selectInteractions(source.crm_lead_id);
        if (res.is_success) items.push(...(res.data ?? []).map(fromLeadInteraction));
    }
    if (source.ts_phuhuynh_id) {
        const res = await chamSocKhachHangApi.select({ ts_phuhuynh_id: source.ts_phuhuynh_id, ts_hocsinh_id: 0, ts_hoso_survey_id: 0 });
        if (res.is_success && Array.isArray(res.data)) {
            // Lead đã gắn phụ huynh: tương tác Lead có thể nằm ở cả 2 nguồn, giữ bản đầu tiên
            res.data.forEach((row: ts_chamsockhachhang) => {
                if (!items.some(x => x.id === row.id)) items.push(fromCskhRow(row));
            });
        }
    }
    return items.sort((a, b) => toTime(b.ngay_tao) - toTime(a.ngay_tao) || b.id - a.id);
};
